export { GEOJSON_FEATURE_TYPE } from 'components/Map/hooks/useFeatures/constants';

export const MS_PER_DAY = 1000 * 60 * 60 * 24;
